// extracted by mini-css-extract-plugin
module.exports = {"changing-text-color":"RelevantTools_changing-text-color__90G88","blink":"RelevantTools_blink__S32ia"};